import {useState} from "react";
import {useTranslation} from "react-i18next";
import Modal from '../components/Modals/FooterModal';
import '../css/views/Footer.css'

const Footer =  () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const { t } = useTranslation();

    const disclaimerClick = () => {
        //setModalTitle(t('Disclaimer.title'));
        setModalTitle(t('Disclaimer.title'));
        const content = t('Disclaimer.content');
        setModalContent(content);
        openModal();
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    /* eslint-disable jsx-a11y/anchor-is-valid */
    return(
        <div className='footer'>
            <div className='footer-content-container'>
            <div className='footer-content'>

                <div style={{ marginRight: "1%", cursor:"pointer"}}>
                    <a onClick={disclaimerClick}>
                        <h2>Disclaimer</h2>
                    </a>

                </div>

                <div style={{ marginRight: "1%"}}>
                    <h2>|</h2>
                </div>

                <div style={{cursor:"pointer" }}>
                    <a onClick={disclaimerClick}>
                        <h2>Privacy Policy</h2>
                    </a>
                </div>

            </div>

            {isModalOpen && (
                <Modal
                    isOpen={isModalOpen}
                    title={modalTitle}
                    content={modalContent}
                    closeModal={() => setIsModalOpen(false)}
                />
            )}
            </div>
        </div>
    );
};

export default Footer;

